import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

function AppFooter({ className, ...props }: React.ComponentProps<'footer'>) {
    const { t } = useTranslation();

    return (
        <footer
            className={cn(
                'shrink-0 flex items-center justify-between px-7 py-3 text-xs text-text-tertiary border-t border-border-default',
                className,
            )}
            {...props}
        >
            <span>{t('common.allRightsReserved', { year: new Date().getFullYear() })}</span>
        </footer>
    );
}

export { AppFooter };
